module.exports = __webpack_public_path__ + "media/images/backgrounds/tag-d37968d12b30faef726dd0994cc18275.svg";